import React from "react";
import {Auth} from "@aws-amplify/auth";
import TextField from "../../common/TextField";
import ResultMessageText from "../../common/ResultMessageText";
import {withRouter} from "react-router-dom";
import {RequireNewPassword} from 'aws-amplify-react';
import LoginContainer from './components/LoginContainer';
import ActionButton from "../../common/ActionButton";

class NewPasswordPage extends RequireNewPassword {

    constructor(props) {
        super(props);

        this.state = {
            password: '',
            confirmPassword: '',
            errorMessage: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    completeNewPassword = async () => {
        const {history, authData} = this.props;
        const {password} = this.state;
        try {
            let user = await Auth.completeNewPassword(authData, password, null);
            this.props.onStateChange('signedIn', {user});
            history.push('/');
        } catch (err) {
            console.log("Error in NewPasswordPage: ", err);
            this.setState({
                errorMessage: err.message
            });
        }
    };

    handleSubmit(event) {
        const {password, confirmPassword} = this.state;
        event.preventDefault();

        if (password === confirmPassword) {
            this.completeNewPassword();
        } else {
            this.setState({
                errorMessage: "New Password and Confirm Password does not match."
            });
        }
    }

    onChange = event => {
        let target = event.target;
        this.setState({
            [target.id]: target.value
        });
    };

    showComponent(theme) {
        const {password, confirmPassword, errorMessage} = this.state;
        return (
            <LoginContainer>
                <form onSubmit={this.handleSubmit}>
                    <TextField
                        id="password"
                        label="New Password"
                        value={password}
                        valueChanged={this.onChange}
                        type="password"
                        legacyMode={true}>
                    </TextField>
                    <TextField
                        id="confirmPassword"
                        label="Confirm Password"
                        value={confirmPassword}
                        valueChanged={this.onChange}
                        type="password"
                        legacyMode={true}>
                    </TextField>
                    <ActionButton
                        className="mt-4"
                        type="submit"
                        text="Change Password"/>
                </form>
                <ResultMessageText text={errorMessage} success={false}/>
            </LoginContainer>
        );
    }
}

export default withRouter(NewPasswordPage);